function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Renewals");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon-All-Renewals",
  transform: "translate(-1.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-Copy",
  opacity: 0.7,
  transform: "translate(1.000000, 0.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M12.5666667,0.0833333333 L0.766666667,0.0833333333 C0.366666667,0.0833333333 0.0333333333,0.416666667 0.0333333333,0.816666667 L0.0333333333,15.1666667 C0.0333333333,15.5666667 0.366666667,15.9 0.766666667,15.9 L12.5666667,15.9 C12.9666667,15.9 13.3,15.5666667 13.3,15.1666667 L13.3,0.816666667 C13.3,0.416666667 12.9666667,0.0833333333 12.5666667,0.0833333333 Z M12.3666667,14.9666667 L0.966666667,14.9666667 L0.966666667,1.03333333 L12.3666667,1.03333333 L12.3666667,14.9666667 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M3.56666667,13.0833333 L9.76666667,13.0833333 C10.0333333,13.0833333 10.2333333,12.8666667 10.2333333,12.6166667 C10.2333333,12.3666667 10.0166667,12.15 9.76666667,12.15 L3.56666667,12.15 C3.3,12.15 3.1,12.3666667 3.1,12.6166667 C3.1,12.8666667 3.3,13.0833333 3.56666667,13.0833333 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M3.56666667,10.8166667 L9.76666667,10.8166667 C10.0333333,10.8166667 10.2333333,10.6 10.2333333,10.35 C10.2333333,10.0833333 10.0166667,9.88333333 9.76666667,9.88333333 L3.56666667,9.88333333 C3.3,9.88333333 3.1,10.1 3.1,10.35 C3.08333333,10.6 3.3,10.8166667 3.56666667,10.8166667 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M6.31666667,8.56666667 C7.9,8.78333333 9.25,7.55 9.25,6.01666667 C9.25,4.63333333 8.15,3.5 6.76666667,3.45 L6.76666667,2.95 C6.76666667,2.68333333 6.48333333,2.51666667 6.25,2.66666667 L4.65,3.63333333 C4.43333333,3.76666667 4.43333333,4.08333333 4.65,4.21666667 L6.25,5.18333333 C6.48333333,5.31666667 6.76666667,5.16666667 6.76666667,4.9 L6.76666667,4.35 C7.63333333,4.4 8.33333333,5.11666667 8.33333333,6.01666667 C8.33333333,7.05 7.38333333,7.86666667 6.31666667,7.65 C5.61666667,7.5 5.06666667,6.88333333 5,6.16666667 C4.98333333,5.96666667 5,5.75 5.05,5.56666667 C5.08333333,5.46666667 5.03333333,5.36666667 4.95,5.33333333 L4.46666667,5.13333333 C4.36666667,5.1 4.23333333,5.15 4.2,5.25 C4.13333333,5.48333333 4.08333333,5.73333333 4.08333333,5.98333333 C4.08333333,7.26666667 5.05,8.4 6.31666667,8.56666667 Z",
  id: "Path"
})), React.createElement("rect", {
  id: "Rectangle-Copy-13",
  stroke: "#979797",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0.5,
  y: 0.5,
  width: 15,
  height: 15
})));

var SvgRenewalsAll = function SvgRenewalsAll(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRenewalsAll, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/renewals-all.4f7fc88b.svg";
export { ForwardRef as ReactComponent };